import { useAuth } from '../hooks/useAuth.js';

export default function ProfilePage() {
  const { user, logout } = useAuth();
  return (
    <div className="panel">
      <h3 className="panel-title">
        <span><i className="ph ph-user-circle" /> Profile</span>
      </h3>
      <div className="sum-row">
        <div className="sum-card">
          <div className="sum-card-label">Name</div>
          <div className="sum-card-value" style={{ fontSize: 18 }}>{user?.display_name}</div>
        </div>
        <div className="sum-card">
          <div className="sum-card-label">Role</div>
          <div className="sum-card-value" style={{ fontSize: 18 }}>{user?.role}</div>
        </div>
        <div className="sum-card">
          <div className="sum-card-label">Employment</div>
          <div className="sum-card-value" style={{ fontSize: 18 }}>{user?.employment_type?.toUpperCase()}</div>
        </div>
      </div>
      <button className="btn-sm" onClick={logout}>Sign out</button>
    </div>
  );
}
